<template>
	<section :class="['job-filter view-filter ', (openState) ? 'open' : 'close']">
		<div
			class="view-filter__skrim"
			@click="closeJobFilterOverlay"/>
		<div class="view-filter__buttons">

            <v-tooltip
				top
				open-delay="400"
				:disabled="mobile">
                <v-btn
					v-if="showUserMeButton"
					slot="activator"
					fab depressed small
					:class="'user-me-grabber  ' + ((isSelectedUserMeInRole()) ? 'user-me-selected' : 'user-me-not-selected')"
					@click="toggleUserMeInRole(this)"
					:isSelectedUserMeInRole="isSelectedUserMeInRole()">

					<v-avatar size="40">
                        <img :src="extractUserAvatarUrl({ user: currentUser })"/>
                    </v-avatar>

                </v-btn>
                <span class="grey--text text--lighten-3">Me in Any Role</span>
            </v-tooltip>


            <v-tabs
				class="tab-button-groups"
				v-model="activeFilterGroup">


				<v-tab
					:ripple="false">

                    <v-tooltip
                            top
                            open-delay="400"
							:disabled="mobile">
                        <v-btn
                                slot="activator"
                                fab depressed small :color="(appliedFilters.length > 0) ?'primary' : 'grey lighten-1'"
                                :class="['view-filter-btn view-filter-properties-btn white--text',(anyFilterSelected) ? 'filterApplied' :'']"
                                @click="openJobFilter('filter')">
                            <v-icon size="22">filter_list</v-icon>
                        </v-btn>
                        <span class="grey--text text--lighten-3">Filter By Attributes</span>
                    </v-tooltip>

				</v-tab>

				<v-tab v-if="showUserFilter"
					:ripple="false">


                    <v-tooltip
                            top
                            open-delay="400"
							:disabled="mobile">
                        <v-btn
                                slot="activator"
                                fab depressed small color="primary"
                                :class="['view-filter-btn view-filter-people-btn',(anyFilterSelected) ? 'filterApplied' :'']"
                                @click="openJobFilter('person')">
                            <v-icon size="22">person</v-icon>
                        </v-btn>
                        <span class="grey--text text--lighten-3">Filter By Users</span>
                    </v-tooltip>

				</v-tab>
			</v-tabs>
		</div>
		<div :class="['elevation-5 view-filter__overlay ', (this.$router.currentRoute.name === 'jobs-requests') ? 'two-button' : '']">
			<div class="overlay__inner">
				<div class="overlay__header">
					<h2 class="headline">{{labelTitle}} <span class="subheading matched-items">{{getResults}}</span></h2>
				</div>
                <div :class="['overlay__archived',(showUserFilter==false) ? 'one-button' : '']">
                    <v-radio-group class="header__radio" row v-model="includeArchive" @click="includeArchiveClick">
                        <v-radio label="Non-Archived" value="active" ></v-radio>
                        <v-radio class="archive" label="Archived" value="archived" ></v-radio>
                        <v-radio label="All" value="all" ></v-radio>
                    </v-radio-group>

                </div>

                <div class="overlay__filters">

					<v-tabs-items
						class="tab-filter-groups"
						v-model="activeFilterGroup">

						<v-tab-item class="tab-filter-group">
                            <div class="filter-group" v-if="this.$router.currentRoute.name === 'jobs-requests'">
								<filter-list
									class="filter__list"
                                    :items="jobStatusesSubset()"
                                    id="status"
                                    type="jobs"
                                    subheader="Status"
                                    :do-close-all=true
									:dispatch-on-select="filterJobsByStatus"
                                />
							</div>
                            <div class="filter-group" v-if="this.$router.currentRoute.name === 'jobs-manage'">
                                <filter-list
                                    class="filter__list"
                                    :items="jobStatusesSubset()"
                                    id="status"
                                    type="jobs"
                                    subheader="Status"
                                    :do-close-all="true"
                                    :dispatch-on-select="filterJobsByStatus"
                                />
                            </div>
							<div class="filter-group" v-if="this.$router.currentRoute.name === 'jobs-manage'">
								<filter-list
									class="filter__list"
									:items="jobProgresses"
                                    id="progress"
                                    type="jobs"
                                    subheader="Progress"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByProgress"
									/>
							</div>
                            <div class="filter-group" v-if="this.$router.currentRoute.name === 'jobs-manage'">
                                <filter-list
                                        class="filter__list"
                                        :items="specialProgressNoteTreatment"
                                        id="progress_note"
                                        type="jobs"
                                        subheader="Progress Note"
                                        :do-close-all="true"
                                        :dispatch-on-select="filterJobsByProgressNote"
                                />
                            </div>
							<div class="filter-group">
								<filter-list
									class="filter__list column-type"
									:items="jobTypes"
                                    id="type"
                                    type="jobs"
                                    subheader="Type"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByType"
									/>
							</div>
							<div class="filter-group">
								<filter-list
									class="filter__list"
                                    id="department"
                                    type="jobs"
                                    subheader="Dept"
									:items="getScopedDepartments"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByDepartment"
									/>
							</div>
							<div class="filter-group">
								<filter-list
									class="filter__list"
									:items="filterOptions.due_by"
                                    id="due_by"
                                    type="jobs"
                                    subheader="Due By"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByDue"
									/>
							</div>
							<div class="filter-group" v-if="this.$router.currentRoute.name === 'jobs-manage'">
								<filter-list
									class="filter__list"
									:items="jobCreativeRounds"
                                    id="creative_round"
                                    type="jobs"
                                    subheader="Round"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByCreativeRound"
									/>
							</div>
						</v-tab-item>

						<v-tab-item class="tab-filter-group" v-if="showUserFilter">
							<div class="filter-group">
								<filter-list
									class="filter__list"
                                    set-item-classes="max-column-treatment-count-6"
									:items="getUsersByRoleNoPending('requestors')"
                                    id="requestors"
                                    type="jobs"
                                    subheader="Requestor"
                                    :do-close-all=true
									:dispatch-on-select="filterJobsByUserRequestor"
									/>
							</div>
							<div class="filter-group">
								<filter-list
									class="filter__list"
                                    set-item-classes="max-column-treatment-count-6"
									:items="getUsersByRoleNoPending('project_managers')"
                                    id="project_managers"
                                    type="jobs"
                                    subheader="PM"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByUserProjectManager"
									/>
							</div>
							<div class="filter-group">
								<filter-list
									class="filter__list"
                                    set-item-classes="max-column-treatment-count-6"
									:items="getUsersByRoleNoPending('print_project_managers')"
                                    id="print_project_managers"
                                    type="jobs"
                                    subheader="Print PM"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByUserPrintProjectManager"
									/>
							</div>
							<div class="filter-group">
								<filter-list
									class="filter__list"
                                    set-item-classes="max-column-treatment-count-6"
									:items="getUsersByRoleNoPending('premedia_project_managers')"
                                    id="premedia_project_managers"
                                    type="jobs"
                                    subheader="Premedia PM"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByUserPremediaProjectManager"
									/>
							</div>
							<div class="filter-group">
								<filter-list
									class="filter__list"
                                    set-item-classes="max-column-treatment-count-6"
									:items="getUsersByRoleNoPending('art_directors')"
                                    id="art_directors"
                                    type="jobs"
                                    subheader="Art Director"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByUserArtDirector"
									/>
							</div>
							<div class="filter-group">
								<filter-list
									class="filter__list"
                                    set-item-classes="max-column-treatment-count-6"
									:items="getUsersByRoleNoPending('creatives')"
                                    id="creatives"
                                    type="jobs"
                                    subheader="Creative"
                                    :do-close-all="true"
									:dispatch-on-select="filterJobsByUserCreative"
									/>
							</div>
						</v-tab-item>

					</v-tabs-items>
				</div>
				<div class="overlay__footer">
					<v-btn
						class="show-results-btn"
						color="primary"
						@click="closeJobFilter">
						Show Results {{getResults}}
					</v-btn>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
    import Vue from 'vue'
	import { mapState, mapActions, mapGetters } from 'vuex'
	import extractUserAvatarUrl from '@/helpers/extractUserAvatarUrl'
    import cloneDeep from 'lodash/cloneDeep'
	import {
        VUEX_JOBS_APPLY_ARCHIVE_FILTER,
		VUEX_JOBS_APPLY_STATUS_FILTER,
		VUEX_JOBS_APPLY_PROGRESS_FILTER,
        VUEX_JOBS_APPLY_PROGRESS_NOTE_FILTER,
		VUEX_JOBS_APPLY_TYPE_FILTER,
		VUEX_JOBS_APPLY_DEPARTMENT_FILTER,
        VUEX_JOBS_APPLY_DUE_FILTER,
		VUEX_JOBS_APPLY_CREATIVE_ROUND_FILTER,

        VUEX_JOBS_APPLY_USER_REQUESTOR,
        VUEX_JOBS_APPLY_USER_PROJECT_MANAGER,
        VUEX_JOBS_APPLY_USER_PRINT_PROJECT_MANAGER,
        VUEX_JOBS_APPLY_USER_PREMEDIA_PROJECT_MANAGER,
        VUEX_JOBS_APPLY_USER_PREMEDIA_ART_DIRECTOR,
        VUEX_JOBS_APPLY_USER_CREATIVE,

    } from '@/store/constants/jobs'

	import {
		VUEX_UI_SHOW_JOB_FILTER,
		VUEX_UI_HIDE_JOB_FILTER
	} from '@/store/constants/ui'


	import FilterList from '@/components/ui/_global/Filter_List.vue'

	export default {
		name: 'job-filter',

		components: {
			'filter-list' : FilterList
		},


		data:() => ({
			activeFilterGroup: null,
            includeArchive:"active",
            keyChange:1.0, //used to force update
			filterOptions: {
				due_by: [
					{
						name: 'Today',
                        value:'today'
					},
					{
						name: 'Next Day',
                        value:'tomorrow'
					},
					{
						name: 'Next 5 Days',
                        value:'next5'
					},
					{
						name: 'Next 10 Days',
                        value:'next10'
					},
					{
						name: 'Late Jobs',
                        value:'late'
					},
					{
						name: 'Rush Jobs',
                        value:'rush'
					},
					{
						name: '24Hr Rush',
                        value:'24hrush'
					}
				]
			},
            jobStatusesSubset: function() {
                var isRequest = (this.$router.currentRoute.name === 'jobs-manage') ? false : true
                var res = []
                for (var i in this.jobStatuses) {
                    if (this.jobStatuses[i].request_only==isRequest) {
                        var doPush = false
                        if (isRequest) {
                            doPush=true
                        } else {
                            //don't show approved for these roles
                            if (this.$store.getters.currentUserHasRole(SILA_ROLE_JOBS_ART_DIRECTOR)
                            || this.$store.getters.currentUserHasRole(SILA_ROLE_JOBS_CREATIVE)) {
                                if (this.jobStatuses[i].value != SILA_JOB_STATUS_APPROVED) {
                                    doPush=true
                                }
                            } else {
                                doPush=true
                            }

                        }
                        if (doPush) res.push(this.jobStatuses[i]);
                    }
                }
			    return res
            },
            isSelectedUserMeInRole() {
                if (this.keyChange>0) {
                    if (this.appliedFilters) {
                        for (var i in this.appliedFilters) {
                            var key = this.appliedFilters[i]
                            if (key.filterOn === "userMeInRole" && key.value.toString()==="1") {
                                return true
                            }
                        }
                    }
                }
                return false
            },
		}),

        watch: {
            appliedFilters: {
                handler: function (val, oldVal) {
                    //Fix for now
                    //There are timing issues on the appliedFilters
                    //It gets drawn before the data is ready, then not updated
                    //it actually works without this stuff if i have console.logs
                    //but removing console.logs speeds it up, and it breaks
                    this.$nextTick(() => {
                        this.keyChange++
                    })
                    this.keyChange = this.keyChange + 1
                    return val;
                },
                deep:true
            },
            jobsFilterToggler: function(newValue) {
                if (newValue.indexOf('quick') >-1 ) {
                    this.includeArchive="active"
                }
            },
            archiveGlobalSetting: function(newValue) {
                this.includeArchive = newValue
                this.includeArchiveClick()
            }
        },

		computed: {
            ...mapState({
				openState: state => state.ui.jobFilterOverlay.openState,

				currentUser: state => state.auth.currentUser,

				jobs: state => state.jobs.jobs,
                jobsMeta: state => state.jobs.jobsMeta,
                appliedFilters: state => state.jobs.appliedFilters,

				jobCodes: state => state.properties.jobCodes,
				jobCreativeRounds: state => state.properties.jobCreativeRounds,
				jobDepartments: state => state.properties.jobDepartments,
				jobFlags: state => state.properties.jobFlags,
				jobPriorities: state => state.properties.jobPriorities,
				jobProgresses: state => state.properties.jobProgresses,
				jobProgressNotes: state => state.properties.jobProgressNotes,
				jobStatuses: state => state.properties.jobStatuses,
				jobTypes: state => state.properties.jobTypes,

                usersByRoleNoPending: state => state.users.usersByRoleNoPending,
                usersByRoleActive: state => state.users.usersByRoleActive,


				mobile: state => state.mobile.mobile,

                jobsFilterToggler: state => state.jobs.filterToggler,
			}),

			...mapGetters({
				userMeInRoleObject: 'getUserMeInRoleObject',
				currentUserHasRole: 'currentUserHasRole',
                archiveGlobalSetting: 'getArchiveGlobalSetting'
			}),

            anyFilterSelected() {
                let ret = false
                if (this.jobsFilterToggler) {
                    for (let i = 0; i < this.appliedFilters.length; i++) {
                        let obj = this.appliedFilters[i]
                        if (obj.filterOn !== "userMeInRole" && obj.filterOn !== "archived" && obj.filterOn !== "searchTerms") {
                            ret = true
                        }
                    }
                }
                return ret
            },

            specialProgressNoteTreatment() {
                let ret = []
                for (let i=0;i<this.jobProgressNotes.length;i++) {
                    let obj = cloneDeep(this.jobProgressNotes[i])
                    if (obj.name==='') {
                        obj.name = "None"
                    }
                    ret.push(obj)
                }
                return ret
            },

			getResults() {
                let suffix = 'Job'
                if (this.$router.currentRoute.name === 'jobs-requests') {
                    suffix = 'Request'
                }
                let ret = '0 ' + suffix + 's';

                if (this.jobsMeta && this.jobsMeta.filter_counts && this.jobsMeta.filter_counts.grandtotal) {
                    ret = this.jobsMeta.filter_counts.grandtotal
                    if (ret==1) {
                        ret += ' ' + suffix
                    } else {
                        ret+= ' ' + suffix + 's'
                    }
                }
                return (this.appliedFilters.length) ? ret : ""
            },
            labelTitle() {
                let ret = 'Filter Jobs';
                if (this.$router.currentRoute.name === 'jobs-requests') {
                    ret = "Filter Requests"
                }
                return ret
            },


            showUserMeButton() {
                if (this.currentUserHasRole(SILA_ROLE_JOBS_EXECUTIVE) ||
                    this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_APPROVER)) {
                    return false //hide for these two roles
                } else if (this.$router.currentRoute.name === 'jobs-requests') {
                    return false //hide in job requests
                } else if (this.userMeInRoleObject && this.userMeInRoleObject.count <= 1) {
                    return false //hide if 1 or 0 roles
                } else {
			        return true
                }
            },

			getUsersByRoleNoPending() {
                let usersList = null
                if (this.includeArchive==="active") {
                    usersList = this.usersByRoleActive
                } else {
                    usersList = this.usersByRoleNoPending
                }
                return role => {
                    let ret = []
					switch(role) {
						case 'requestors' :
                            ret = (usersList[SILA_ROLE_JOBS_REQUESTOR]) ? usersList[SILA_ROLE_JOBS_REQUESTOR] : []
                            break

						case 'project_managers' :
                            ret = (usersList[SILA_ROLE_JOBS_PROJECT_MANAGER]) ? usersList[SILA_ROLE_JOBS_PROJECT_MANAGER] : []
                            break

						case 'print_project_managers' :
                            ret = (usersList[SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER]) ? usersList[SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER] : []
                            break

						case 'premedia_project_managers' :
                            ret = (usersList[SILA_ROLE_JOBS_PREMEDIA_PROJECT_MANAGER]) ? usersList[SILA_ROLE_JOBS_PREMEDIA_PROJECT_MANAGER] : []
                            break

						case 'art_directors' :
                            ret = (usersList[SILA_ROLE_JOBS_ART_DIRECTOR]) ? usersList[SILA_ROLE_JOBS_ART_DIRECTOR] : []
                            break

						case 'creatives' :
                            ret = (usersList[SILA_ROLE_JOBS_CREATIVE]) ? usersList[SILA_ROLE_JOBS_CREATIVE] : []
                            break
					}

					//pop off current user from middle of list and put at top
                    let ret2 = cloneDeep(ret)
                    let currentUserId = this.currentUser?.id
                    let idx = ret2.findIndex(x => x.id === currentUserId)
					if (idx >-1) {
                        ret2.splice(idx, 1)
                        ret2.unshift(cloneDeep(this.currentUser))
                    }
					return ret2
				}
			},

			/**
			 * ... this one to jobs. Pass the user into the getter and it'll pull the depts off there
			 * and return a filtered result anywhere in the app. Yay DRY!
			 */
			getScopedDepartments() {
				if (!this.currentUser) {
					// Bail if not here (Logout will fail and then user session remains! Danger!!!)
					return
				} else {
					let depts = this.jobDepartments

					if (this.includeArchive==="active" && this.currentUser.access_type === SILA_USER_ACCESS_TYPE_EXTERNAL) {
                        // If the user is an external - AND “active" is SELECTED - show a FILTERED list

                        // ... if they have no depts ...
						if (this.currentUser.requestor_departments === null || !this.currentUser.requestor_departments) {
							return [] // something is wrong on user, don't allow select any
						} else {
							// ... they do have depts and we can filter by it.
							let userPerms = this.currentUser.permissions
							let userDepts = this.currentUser.requestor_departments

							// if JOB_CREATE
							if (userPerms.map(perm => perm === SILA_PERMISSION_JOBS_JOB_CREATE)) {
								// If SCOPE_DEPARTMENT get departments from user else return ALL departments
								return userPerms.filter(perm => perm === SILA_PERMISSION_JOBS_JOB_CREATE_SCOPE_DEPARTMENT) ?
									depts.filter(dept => { if( userDepts.filter(uDept => uDept === dept.value ).length > 0 ) return dept })
									: depts
							}
						}
					} else {
						// Is internal, and no need to filter further
						return depts
					}
				}

				return [] // fallback
			},

            showUserFilter() {
			    if (this.$router.currentRoute.name === 'jobs-manage') {
                    return true
                } else if (
                    this.currentUserHasRole(SILA_ROLE_JOBS_EXECUTIVE) ||
                    this.currentUserHasRole(SILA_ROLE_JOBS_PRINT_APPROVER)) {
                    return true
                } else {
                    return false
                }
            }
		},

		methods: {
			extractUserAvatarUrl,

			...mapActions({
				openJobFilterOverlay: VUEX_UI_SHOW_JOB_FILTER,
				closeJobFilterOverlay: VUEX_UI_HIDE_JOB_FILTER,

                filterJobsByStatus: VUEX_JOBS_APPLY_STATUS_FILTER,
                filterJobsByProgress: VUEX_JOBS_APPLY_PROGRESS_FILTER,
                filterJobsByProgressNote: VUEX_JOBS_APPLY_PROGRESS_NOTE_FILTER,
                filterJobsByType: VUEX_JOBS_APPLY_TYPE_FILTER,
                filterJobsByDepartment: VUEX_JOBS_APPLY_DEPARTMENT_FILTER,
                filterJobsByDue: VUEX_JOBS_APPLY_DUE_FILTER,
				filterJobsByCreativeRound: VUEX_JOBS_APPLY_CREATIVE_ROUND_FILTER,

                filterJobsByUserRequestor:VUEX_JOBS_APPLY_USER_REQUESTOR,
                filterJobsByUserProjectManager:VUEX_JOBS_APPLY_USER_PROJECT_MANAGER,
                filterJobsByUserPrintProjectManager:VUEX_JOBS_APPLY_USER_PRINT_PROJECT_MANAGER,
                filterJobsByUserPremediaProjectManager:VUEX_JOBS_APPLY_USER_PREMEDIA_PROJECT_MANAGER,
                filterJobsByUserArtDirector:VUEX_JOBS_APPLY_USER_PREMEDIA_ART_DIRECTOR,
                filterJobsByUserCreative:VUEX_JOBS_APPLY_USER_CREATIVE,

			}),


			openJobFilter(type){
				document.body.style.position = 'fixed'
				this.openJobFilterOverlay()

                if (type=='person') {
                    window.Appcues.track("Open Job People Filters");
                } else {
                    window.Appcues.track("Open Job Property Filters");
                }
			},

			closeJobFilter(){
				document.body.style.position = ''
				this.closeJobFilterOverlay()
			},

            toggleUserMeInRole() {
                if (this.keyChange>0) {
                    var issel = this.isSelectedUserMeInRole();
                    if (issel) {
                        this.$store.dispatch('VUEX_JOBS_REMOVE_USER_ME_IN_ROLE', {value: ""})
                    } else {
                        this.$store.dispatch('VUEX_JOBS_APPLY_USER_ME_IN_ROLE', {value: ""})
                    }
                }
			},

            includeArchiveClick() {
                //dispatch
                this.$store.dispatch('VUEX_JOBS_APPLY_ARCHIVE_FILTER', { value: this.includeArchive})

                //SET FILTER_TOGGLER
                this.$store.dispatch('VUEX_JOBS_SET_FILTER_TOGGLER', { value: "manual"})

            },


        }
	}
</script>
